"use client";

import React from "react";
import { Container } from "@/components/container";
import { Accordion, AccordionItem } from "@heroui/react";

export const FAQContentContainer = ({ initialData }) => {
  return (
    <Container className="py-12 md:py-24 lg:max-w-3xl">
      <Accordion variant="splitted" defaultExpandedKeys={["0"]}>
        {initialData?.questions?.map((item, index) => (
          <AccordionItem
            key={index}
            aria-label={item?.question}
            title={item?.question}
          >
            {item?.answer}
          </AccordionItem>
        ))}
      </Accordion>
    </Container>
  );
};
